import {Injectable} from '@angular/core';
import {ApiService} from "../global/api.service";
import {Category} from "../../types/models";
import {ProductService} from './product.service';
import {RecipeService} from './recipe.service';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {


  constructor(
    private api: ApiService,
    private productService: ProductService,
    private recipeService: RecipeService
  ) {
  }

  getIcons(): string[] {
    return [
      'alcohol.svg',
      'animal.svg',
      'asian.svg',
      'baby.svg',
      'backing.svg',
      'barbeque.svg',
      'beverages.svg',
      'bio.svg',
      'bread.svg',
      'cheese.svg',
      'coffee.svg',
      'convenience.svg',
      'cosmetics.svg',
      'dairy.svg',
      'fish.svg',
      'fruits.svg',
      'german.svg',
      'household.svg',
      'ice.svg',
      'international.svg',
      'meat.svg',
      'new.svg',
      'pasta.svg',
      'salad.svg',
      'sausage.svg',
      'soups.svg',
      'stew.svg',
      'storage.svg',
      'sweets.svg',
      'vegan.svg',
      'vegetables.svg'
    ];
  }

  setIcons(categories: Category[]) {
    for (const category of categories || []) {
      if (category.Icon) {
        category.Icon = 'assets/icons/categories/' + category.Icon
      }
    }
  }

  public async getAllProductCategories(): Promise<Category[]> {
    const categories = await this.api.get('category/product');
    this.setIcons(categories);
    return categories;
  }

  public async getAllProductCategoriesByParent(categoryId: string): Promise<Category[]> {
    const categories = await this.api.get('category/product/children/' + categoryId);
    this.setIcons(categories);
    return categories;
  }

  public async getAllRecipeCategories(): Promise<Category[]> {
    const categories = await this.api.get('category/recipe');
    this.setIcons(categories);
    return categories;
  }

  public async getAllRecipeCategoriesByParent(categoryId: string): Promise<Category[]> {
    const categories = await this.api.get('category/recipe/children/' + categoryId);
    this.setIcons(categories);
    return categories;
  }

  public async getProductCategory(id: string): Promise<Category> {
    const category = await this.api.get(`category/product/${id}`);
    if (category) {
      category.Products = this.productService.sortProductsByAvailability(category.Products);
      for (const product of category.Products || []) {
        product.BasePrice = this.productService.getPricePerBaseUnit(product);
        product.BaseAmount = this.productService.getBaseAmount(product);
      }
    }
    return category;
  }

  public async getRecipeCategory(id: string): Promise<Category> {
    const category = await this.api.get(`category/recipe/${id}`);
    if (category) {
      category.Recipes = this.recipeService.sortRecipesByAvailability(category.Recipes);
      (category.Recipes || []).forEach(recipe => this.recipeService.setPrice(recipe));
    }
    return category;
  }

}
